import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpRequest, HttpEventType } from '@angular/common/http';
import { BASE_URI, config } from './../../app.config';

@Injectable()

export class AttendanceService {

  /** specifying Base URL.*/
  public BASE_URL = BASE_URI.URL;


  constructor(){}




}
